<div #wrapper>
  <form #searchForm="ngForm" novalidate class="d-flex justify-content-start align-items-center" [class.sub]="subSearch" (ngSubmit)="searchForm.valid && search()">
    <input #searchField class="form-control" type="search" name="field" [class.expanded]="isExpanded" [(ngModel)]="field" (change)="change()">
    <a class="nav-link" (click)="searchForm.valid && search()" [routerLink]="">
      <span><i class="icon icon-search" aria-hidden="true"></i></span>
    </a>
  </form>
</div>
